import React, { useEffect, useState } from "react";
import Logo from "../../Components/SVGs/Logo";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { notification } from "antd";
import { AdminService } from "deliziora-client-module/client-web";

export default function LoginPageAdmin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    admin_password: "",
  });

  useEffect(() => {
    const adminData = localStorage.getItem("adminData");
    if (adminData) {
      navigate("/admin");
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    AdminService.returnLoginByEmailPassword(
      formData.email,
      formData.admin_password
    )
      .then((data) => {
        console.log(data);
        localStorage.setItem("adminData", JSON.stringify(data.data))
        /* navigate("/admin"); */
        window.location.reload()
      })
      .catch((error) => {
        console.error(error);
        notification.open({
          message: "Erro ao por os Dados",
          description: "Por favor verifique o email e password inseridos",
        });
      });
    console.log("Form submitted with data:", formData);
  };

  return (
    <div className="container_login">
      <h1 className="login_title" style={{ 
        fontSize: "30px",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "50px",
        color: "#F36528"
       }}>Login Admin</h1>
      <div className="logo_container">
        <Logo />
        <div>
          <h1>Telabite</h1>
        </div>
      </div>
      <div className="input_container">
        <div>
          <form className="input_box" onSubmit={handleSubmit}>
            <input
              type="email"
              className="input_item"
              placeholder="Nome de Utilizador"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            <input
              type="password"
              className="input_item"
              placeholder="Password"
              name="admin_password"
              value={formData.admin_password}
              onChange={handleInputChange}
            />
            <input type="submit" value="Login" className="input_submit" />
          </form>
        </div>
      </div>
    </div>
  );
}
